<template>
  <template v-if="loading">
    <AppContentLoader />
  </template>

  <template v-else>
    <PlanDocument
      :plan="revision"
      :nodes="nodes"
      :edges="edges"
      :frameworks="frameworks"
    />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { DataSet } from 'vis-data';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { useHttp } from '@/composables';
import { AppContentLoader } from '@/components/app/index';
import { PlanDocument } from '@/components/plan';

const route = useRoute();

const loading = ref(true);
const revision = ref();
const frameworks = ref(null);
const nodes = ref();
const edges = ref();

const loadRevision = async () => {
  const response = await useHttp().get(`/plans/${route.params.plan}/revisions/${route.params.revision}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    revision.value = response.data;

    nodes.value = new DataSet(revision.value.nodes || []);
    edges.value = new DataSet(revision.value.edges || []);
  }
};

const loadFrameworks = async () => {
  const response = await useHttp().get('/util/frameworks');

  if (response.statusCode === HttpStatusCode.Ok) {
    frameworks.value = response.data.items;
  }
};

Promise
  .all([
    loadRevision(),
    loadFrameworks(),
  ])
  .then(() => {
    loading.value = false;
  });

</script>
